import React from "react";
import { useQuery } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const PageTitleCard = ({ children }) => {
  const { data, isLoading } = useQuery({
    queryKey: "getbannerImage",
    queryFn: () =>
      axios.get(`${BASEURL}images`).then((res) => {
        return res?.data;
      }),
  });

  return (
    <>
      {isLoading && (
        <Skeleton className="w-full lg:h-48 md:h-48 sm:h-48  max-sm:h-48" />
      )}
      {!isLoading && (
        <div className="flex  items-center w-full lg:h-48 md:h-48 sm:h-48  max-sm:h-48 relative overflow-hidden ">
          {Array.isArray(data?.images) &&
            data?.images?.map((v, i) => (
              <div
                className="w-full h-full absolute blur-sm contrast-100 -z-10"
                style={{
                  backgroundImage: `url(${v?.image_url})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
            ))}

          <div className="flex lg:flex-row lg:justify-between md:justify-between md:flex-row sm:justify-center sm:flex-col max-sm:flex-col max-sm:justify-center items-center px-16 w-full">
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default PageTitleCard;
